import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getProductsBySubjectId, getProductsBySubjectIdStatus } from '../../../reducers/dashboard.selectors';
import { AsyncActionStatus } from '../../../actions/common.actionTypes';
import NewCarousel from '../../Carousel/NewCarousel';
import useRouter from '../../../utils/useRouter';
import { CAROUSEL_DEFAULT_QUERY_OPTIONS, numberOfSlides, routes } from '../../../constants';
import { useTranslation } from 'react-i18next';
import querystring from 'query-string';
import { SearchFilters, SearchResultsTab } from '../../../types/search';
import { selectUser } from '../../../reducers/user.selectors';
import useAction from '../../../utils/useAction';
import { fetchProductsByQuery as fetchProductsByQueryAction } from '../../../actions/product.actions';
import { getCommonCardProps } from '../../Search/SearchResults/SearchResults';
import DashboardMuiCard from '../../cards/MuiCard/DashboardMuiCard';
import { dashboardCardDimensions } from '../../../assets/styles/themes/tokens';
import CardSkeleton from '../../Carousel/CardSkeleton';

const StudyflixCarousel: React.FC = () => {
  const { t } = useTranslation();
  const { router } = useRouter();
  const slides = new Array(numberOfSlides.xl).fill(null);
  const user = useSelector(selectUser);
  const keyPrefix: string = 'Studyflix';
  const userSubjects = user?.subjectsFlattened || [];
  const subjectQueryParameter: string = userSubjects.map(sub => sub.id).join(','); 
  const loadingStatus = useSelector(state => getProductsBySubjectIdStatus(state, subjectQueryParameter, keyPrefix));  
  const fetchProductsByQuery = useAction(fetchProductsByQueryAction);
  const products = useSelector(state => getProductsBySubjectId(state, subjectQueryParameter, keyPrefix));

  useEffect(() => {
    if (!user) {
      return;
    }    
    fetchProductsByQuery({
      includePublishers: 'Studyflix',
      subjects: userSubjects.map(sub => sub.id),
      keyPrefix,
    }, CAROUSEL_DEFAULT_QUERY_OPTIONS);
  }, [user?.subjects]);

  if (products.length < numberOfSlides.xl) return null;

  const onShowAllClick = () => {
    const searchParams: SearchFilters = {
      sortBy: 'createdDate',
      publisher: ['Studyflix'],
    };

    const qs = querystring.stringify(searchParams, { skipNull: true });
    const uri = `/${routes.search.root}/${SearchResultsTab.PRODUCTS}?${qs}`;

    router.push(uri);
  };

  return (
    <NewCarousel 
      title={t('Videos from Studyflix')}
      onShowAll={onShowAllClick}
      cardWidth={dashboardCardDimensions.video.width}
    >
      {loadingStatus === AsyncActionStatus.READY ? (
        products.map((product, index: number) => (
          <DashboardMuiCard
            key={index}
            contentType={'product'}
            {...getCommonCardProps({ ...product, type: 'product' })}
            isVideo
            redirectToMindItemId={product.mindItems[0]}          />
        ))
      ) : slides.map((_, index) => <CardSkeleton key={index} />)}
    </NewCarousel>

  );
};

export default React.memo(StudyflixCarousel);
